import { Card, Placeholder, Row, Col } from "react-bootstrap";
import { BiSupport } from "react-icons/bi";
import MainCard from "../Cards/MainCard";
import { Skeleton } from "antd";

const CustomerSupportSkeleton = () => {
  return (
    <>
      <div style={{ width: "200px" }}>
        <Placeholder.Button variant="secondary" xs={6} />
      </div>

      <MainCard>
        {/* Section Heading */}
        <span className="d-flex gap-2 align-items-center mb-3">
          <BiSupport size={"28px"} />
          <Placeholder as="h5" animation="wave" className="w-25">
            <Placeholder xs={6} />
          </Placeholder>
        </span>
        {/* Fake Table Skeleton */}
        {[...Array(5)].map((_, idx) => (
          <Row
            key={idx}
            className="align-items-center border-bottom py-2 mb-2"
            style={{ minHeight: "40px" }}
          >
            <Col md={3}>
              <Placeholder as="p" animation="wave">
                <Placeholder xs={8} />
              </Placeholder>
            </Col>
            <Col md={2}>
              <Placeholder as="p" animation="wave">
                <Placeholder xs={6} />
              </Placeholder>
            </Col>
            <Col md={2}>
              <Placeholder as="p" animation="wave">
                <Placeholder xs={5} />
              </Placeholder>
            </Col>
            <Col md={2}>
              <Placeholder as="p" animation="wave">
                <Placeholder xs={7} />
              </Placeholder>
            </Col>
            <Col md={2}>
              <Placeholder as="p" animation="wave">
                <Placeholder xs={5} />
              </Placeholder>
            </Col>
            <Col md={1}>
              <Placeholder.Button variant="secondary" xs={6} />
            </Col>
          </Row>
        ))}
      </MainCard>
    </>
  );
};

export default CustomerSupportSkeleton;
